const categoryIcons = {
  av_equipment: 'av',
  dropoffs_deliveries: 'delivery2',
  experiences: 'experiences',
  extra_space: 'extra_space',
  food_drinks: 'food',
  furniture: 'chair',
  office_supplies: 'office_supplies',
  other: 'other',
  parking: 'parking',
  party_addons: 'party_disco',
  production_equipment: 'camera',
  staffing: 'person',
  table_settings: 'utensils_plates',
  'non-alcoholic_drinks': 'beverage',
  alcoholic_drinks: 'full-bar',
  full_bar_package: 'full-bar',
  bar_services: 'full-bar',
  backdrops: 'backdrop',
  lighting: 'lamp',
  props: 'star',
  grips: 'grip',
  power_supplies: 'power-cord',
  ladder: 'ladder'
};

export default categoryIcons;
